import { useEffect, useState } from 'react'
import { searchPositionAssetListInstruments } from '../lib/positionAssetListStore.js'
import { stockInfoRequest } from '../lib/stockInfoClient.js'
import { earningsRequest } from '../lib/earningsClient.js'
import { isOCCSymbol } from '../lib/occParser.js'

export function useAssetInfo(symbol, userId) {
  const [state, setState] = useState(null)
  const supported = /^[A-Z][A-Z0-9.\-]{0,23}$/.test(symbol || '') && !isOCCSymbol(symbol)
  useEffect(() => {
    if (!supported || !userId) return
    let disposed = false
    let busy = false
    let controller
    const refresh = async () => {
      if (busy || document.visibilityState === 'hidden') return
      busy = true
      controller = new AbortController()
      const timeout = setTimeout(() => controller.abort(), 18_000)
      const publish = patch => {
        if (!disposed) setState(previous => ({ ...(previous?.symbol === symbol && previous?.userId === userId ? previous : {}), symbol, userId, ...patch }))
      }
      const signal = controller.signal
      await Promise.allSettled([
        searchPositionAssetListInstruments(symbol, { profile: true, signal }).then(result => {
          const candidates = result.results?.filter(item => item.symbol === symbol) || []
          publish({ profile: candidates.length === 1 ? candidates[0] : null, status: candidates.length === 1 ? 'ready' : 'unavailable' })
        }).catch(() => publish({ profile: null, status: 'unavailable' })),
        stockInfoRequest(symbol).then(fundamentals => publish({ fundamentals })).catch(() => publish({ fundamentals: null })),
        earningsRequest(symbol).then(earnings => publish({ earnings })).catch(() => publish({ earnings: null })),
      ])
      clearTimeout(timeout)
      busy = false
    }
    refresh()
    const timer = setInterval(refresh, 5 * 60_000)
    window.addEventListener('focus', refresh)
    return () => { disposed = true; controller?.abort(); clearInterval(timer); window.removeEventListener('focus', refresh) }
  }, [symbol, userId, supported])
  if (!supported) return { status: 'unsupported' }
  return state?.symbol === symbol && state?.userId === userId ? state : { status: userId ? 'loading' : 'unavailable' }
}
